import apiClient from "utils/apiClient";

export const switchUserAppRole = (role) => {
  const normalizedRole = String(role || "").toUpperCase() === "HELPER" ? "HELPER" : "REQUESTER";
  return apiClient
    .put(`/olitask-service/api/v1/user-profiles/switch-role?role=${encodeURIComponent(normalizedRole)}`)
    .then((response) => response.data);
};

export default switchUserAppRole;
